import { NETWORK } from "global_constants";
import Contracts from "contracts/hardhat_contracts.json";

export const getContractConfig = (chainId, contract) => {
  return Contracts[chainId][NETWORK.CHAIN_ID_TO_NAME[parseInt(chainId)]][
    "contracts"
  ][contract];
};
